import { DEFAULT_PALETTE } from '../../core/palette';
import type { ParamSchema, SchemaValues } from '../../core/params/types';

export const GAME_OF_LIFE_PARAMS = [
  {
    kind: 'float',
    key: 'cell',
    label: 'Zellgrösse',
    min: 1,
    max: 40,
    step: 0.5,
    scale: 'log',
    default: 6,
    unit: 'px',
    bulkRange: [3, 16],
    group: 'Automat',
  },
  {
    kind: 'enum',
    key: 'ruleset',
    label: 'Regelsatz',
    default: 'conway',
    group: 'Automat',
    options: [
      { value: 'conway', label: 'Conway (B3/S23)' },
      { value: 'highlife', label: 'HighLife (B36/S23)' },
      { value: 'daynight', label: 'Day & Night' },
      { value: 'seeds', label: 'Seeds (B2/S)' },
      { value: 'maze', label: 'Maze (B3/S12345)' },
      { value: 'custom', label: 'Eigene B/S-Notation' },
    ],
  },
  {
    kind: 'text',
    key: 'customRule',
    label: 'B/S-Notation',
    default: 'B3/S23',
    group: 'Automat',
    showIf: (v) => v.ruleset === 'custom',
    tooltip: 'Geburt/Überleben, z. B. B36/S23.',
    bulkValues: ['B3/S23', 'B36/S23', 'B2/S', 'B3/S12345', 'B345/S5678'],
  },
  {
    kind: 'int',
    key: 'generations',
    label: 'Generationen',
    min: 1,
    max: 400,
    step: 1,
    default: 24,
    bulkRange: [3, 90],
    group: 'Automat',
  },
  {
    kind: 'enum',
    key: 'textRole',
    label: 'Rolle des Textes',
    default: 'start',
    group: 'Automat',
    options: [
      { value: 'start', label: 'Startzustand' },
      { value: 'fixed', label: 'Unveränderliche Zellen' },
      { value: 'outside', label: 'Start ausserhalb' },
      { value: 'blocked', label: 'Sperrzone' },
    ],
  },
  {
    kind: 'float',
    key: 'noise',
    label: 'Startrauschen',
    min: 0,
    max: 1,
    step: 0.01,
    default: 0.12,
    group: 'Automat',
    tooltip: 'Anteil zusätzlich zufällig belebter Zellen.',
  },
  {
    kind: 'bool',
    key: 'wrap',
    label: 'Ränder verbinden',
    default: false,
    group: 'Automat',
  },

  {
    kind: 'enum',
    key: 'display',
    label: 'Darstellung',
    default: 'trails',
    segmented: true,
    group: 'Darstellung',
    options: [
      { value: 'current', label: 'Letzte' },
      { value: 'trails', label: 'Alle Generationen' },
    ],
  },
  {
    kind: 'float',
    key: 'gap',
    label: 'Zellabstand',
    min: 0,
    max: 0.6,
    step: 0.01,
    default: 0.12,
    group: 'Darstellung',
  },
  {
    kind: 'bool',
    key: 'round',
    label: 'Runde Zellen',
    default: false,
    group: 'Darstellung',
  },
  {
    kind: 'float',
    key: 'opacity',
    label: 'Deckkraft',
    min: 0.05,
    max: 1,
    step: 0.01,
    default: 0.9,
    group: 'Darstellung',
  },

  {
    kind: 'palette',
    key: 'palette',
    label: 'Palette',
    default: { ...DEFAULT_PALETTE, paletteId: 'acid' },
    group: 'Farbe',
  },
] as const satisfies ParamSchema;

export type GameOfLifeValues = SchemaValues<typeof GAME_OF_LIFE_PARAMS>;
